import { render, staticRenderFns } from "./coverageReview.vue?vue&type=template&id=13cd5371&"
import script from "./coverageReview.vue?vue&type=script&lang=js&"
export * from "./coverageReview.vue?vue&type=script&lang=js&"
import style0 from "./coverageReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "coverageReview.vue"
export default component.exports